import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/default/header";
import SidebarMenu from "../menu/sidebarMenu";
import Breadcrumb from "../../default/breadcrumb/breadcrumb";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { getUserNotification, updateUserNotification } from "../../../store/actions/new/userUpdateAction";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { loginOutAction } from "../../../store/actions/authActions";

const UserSettings = () => {
    const [notificationSettings, setNotificationSettings] = useState({
        notificationStatus: 0,
        allowCardNotification: 0,
        allowContactNotification: 0,
    });
    const [initialSettings, setInitialSettings] = useState(notificationSettings);
    const [errorMessage, setErrorMessage] = useState(''); 
    const [copyMessage, setCopyMessage] = useState('Copy'); 
    const [copyIcon, setCopyIcon] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();


    
    useEffect(() => {
       dispatch(getUserNotification());
    }, [dispatch]);

    // store data
    const storeData = useSelector((state) => state.userData);
    const {notification} = storeData.settings
    useEffect(() => {
        if (notification) {
            const fetchedSettings = {
                notificationStatus: notification.notificationStatus !== undefined ? notification.notificationStatus : 0,
                allowCardNotification: notification.allowCardNotification !== undefined ? notification.allowCardNotification : 0,
                allowContactNotification: notification.allowContactNotification !== undefined ? notification.allowContactNotification : 0,
            };
            setNotificationSettings(fetchedSettings);
        }
    }, [notification]);

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setNotificationSettings((prevSettings) => ({
            ...prevSettings,
            [name]: checked ? "1" : "0",
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault(); 
        if (
            JSON.stringify(notificationSettings) !== JSON.stringify(initialSettings)
        ) {
            dispatch(updateUserNotification({"items":notificationSettings}));
        }else{
            setErrorMessage("No changes detected. Please modify the settings before submitting.");
        }
       
    };
    
    // use id copy function
    const handleCopy = async () => {
        const userId = notification.userID;
        try {
            // Try modern clipboard API first
            if (navigator.clipboard) {
                await navigator.clipboard.writeText(userId);
                setCopyIcon('ri-check-double-line');
                setCopyMessage('Copied');
            } else {
                // Fallback for older browsers
                const textArea = document.createElement('textarea');
                textArea.value = userId;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setCopyIcon('ri-check-double-line');
                setCopyMessage('Copied');
            }
        } catch (err) {
            console.error("Failed to copy: ", err);
            setCopyMessage("Failed to copy");
        } finally {
            // Reset the message after 2 seconds
            setTimeout(() => {
                setCopyMessage('Copy');
                setCopyIcon('');
            }, 2000);
        }
    };

    // Delete Account
    const MySwal = withReactContent(Swal)
    const handleDeleteUser = (e) => {
        e.preventDefault();
        MySwal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#ccc",
            confirmButtonText: "Conform",
            didOpen: () => {
                document.body.style.overflow = "hidden"; 
              },
              willClose: () => {
                document.body.style.overflow = ""; 
              }
        }).then(async (result) => {
            if (result.isConfirmed) {
              let response = await axios.delete('/user/delete');
              if(response.status >= 200){
                dispatch(loginOutAction(navigate));
              }
            }
        });

    }

    return (
        <div className="menu-with-settings sidebar-menu-enable">
            <Helmet><title>Settings</title></Helmet>
            <Header />
            <div className="sidebar-with-content ds-flex">
                <SidebarMenu />
                <div className="content-right">
                    <Breadcrumb />
                    <div class="connection-header common-header">
                        <h3>Update profile</h3>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="settings-list-wrapper">
                            <div className="single-settings">
                                <label className="setting-title">Push notifications</label>
                                <div className="setting-content">
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <h5>All Notifications</h5>
                                            <p>Manage all notifications with a single switch.</p>
                                        </div>
                                        <div className="sng-toggle-button">
                                            <div className="pricing-switch">
                                                <label className="switch">
                                                    <input 
                                                        id="allow-notification" 
                                                        type="checkbox" 
                                                        name="notificationStatus" 
                                                        checked={notificationSettings.notificationStatus === "1" ? 1 : 0} 
                                                        onChange={handleCheckboxChange} 
                                                        
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <h5>Card Activity Notifications</h5>
                                            <p>Stay updated on views and visitor activity on your cards.</p>
                                        </div>
                                        <div className="sng-toggle-button">
                                            <div className="pricing-switch">
                                                <label className="switch">
                                                    <input 
                                                        id="view-card" 
                                                        type="checkbox" 
                                                        name="allowCardNotification" 
                                                        checked={notificationSettings.allowCardNotification === "1" ? 1 : 0} 
                                                        onChange={handleCheckboxChange} 
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sng-content-repeater">
                                        <div className="sng-content">
                                            <h5>Connection Notifications</h5>
                                            <p>Get alerts for contact or connection updates.</p>
                                        </div>
                                        <div className="sng-toggle-button">
                                            <div className="pricing-switch">
                                                <label className="switch">
                                                    <input 
                                                        id="visitor-activity" 
                                                        type="checkbox" 
                                                        name="allowContactNotification" 
                                                        checked={notificationSettings.allowContactNotification === "1" ? 1 : 0} 
                                                        onChange={handleCheckboxChange} 
                                                    />
                                                    <span className="slider round"></span>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="single-settings border-none">
                                <label className="setting-title">More actions</label>
                                <div className="setting-content">
                                    <div className="sng-content-repeater">
                                        <div className="sng-content copy-wrapper">
                                            <h5>Your Profile ID: #<span className="user-profile-id">{notification.userID}</span> 
                                                <span onClick={handleCopy} className="copy-text">
                                                    <i className={copyIcon}></i> {copyMessage}
                                                </span>
                                            </h5>
                                            <p>Delete your account permanently</p>
                                            <button className="btn delete-btn" onClick={(e) => handleDeleteUser(e)}><i className="ri-delete-bin-line"></i> Delete Account</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="button-wrapper form-error-wrapper">
                                {errorMessage && <div className="error-message" style={{ color: 'red' }}>{errorMessage}</div>}
                                <button className="btn submit-btn bg-primary">Save updates</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default UserSettings;